<template>
  <div class="pm-dialog-tug-boats">
    <div class="flex justify-center dialog-content" style="padding:1rem;">
      <div class="vs-col pm-dialog-equipment-col" v-for="(master,index) in masterList" :key="index" style="margin:0.2rem;" @mousedown="onClick(master.id)">
        <vs-chip
          class="pm-input-key"
          style="min-width:7rem;"
          :color="itemColor(master.id)"
          :transparent="itemTransparent(master.id)"
          :class="[ itemTransparent(master.id) ? 'pm-chip-with-border' : 'pm-chip-without-border' ]"
        >
          {{ master.name }}
        </vs-chip>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      isCount : false,
      selectedIds: [],
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      let masterList = [];
      if ( this.isCount === true) {
        const listLength = this.masterMap['tug_boats'].length;
        for ( let i=1 ; i <= listLength ; i++ ) {
          masterList.push({ id: i ,name: i + 'T' });
        }
      } else {
        masterList = this.masterMap['tug_boats'];
      }
      return masterList;
    },
    enableSave() {
      return true; // ( this.selectedIds && this.selectedIds.length > 0 );
    },
  },
  methods: {
    initData() {
      this.isCount = this.valueMap && this.valueMap.is_count ? this.valueMap.is_count : false;
      if ( this.isCount === true ) {
        this.selectedIds = this.valueMap && this.valueMap.count ? [{ id: this.valueMap.count, name: this.valueMap.count + 'T', status: 3}] : [];
      } else {
        this.selectedIds = this.valueMap && this.valueMap.value ? JSON.parse(JSON.stringify(this.valueMap.value)) : [];
      }
    },
    itemColor(masterId) {
     let foundId =  this.selectedIds.find(idMap => idMap.id === masterId);
      let itemColorCode = null;
      if ( foundId ) {
         if ( foundId.status === 2 ) {
           itemColorCode = '#081e29';
         } else if (foundId.status === 3 ) {
           itemColorCode = '#2d9cdb';
         }
      }
      return itemColorCode;
    },
    itemTransparent(masterId) {
     let foundId =  this.selectedIds.find(idMap => idMap.id === masterId);
      let isTransparent = false;
      if ( foundId ) {
         if ( foundId.status === 2 ) {
           isTransparent = true;
         }
      }
      return isTransparent;
    },
    onClick(masterId) {
      let foundSelectedId = this.selectedIds.find(idMap => idMap.id === masterId);
      if (foundSelectedId) {
        foundSelectedId.status = ( foundSelectedId.status % 3 ) + 1
        if ( this.isCount === true ) {
          if ( foundSelectedId.status === 2 ) { foundSelectedId.status = 3; } // 予約状態は存在しない。 
          this.selectedIds = [] ;
          this.selectedIds.push( foundSelectedId );
        }
      } else {
        let newSelectedId = JSON.parse(JSON.stringify(this.masterList.find(master => master.id === masterId)));
        newSelectedId.status = 3;
        if ( this.isCount === true ) {
          this.selectedIds = [] ;
        }
        this.selectedIds.push( newSelectedId );
      }
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = ["update"];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      let idMap = {};
      const updateKeyValueMap = {};
      if ( this.isCount === true) {
        let newSelectedId = null;
        this.selectedIds.forEach(selectedId => {
          if ( [2,3].includes(selectedId.status)  ) {
            newSelectedId = Number(selectedId.id);
          }
        });
        updateKeyValueMap[this.columnKey + '#count'] = newSelectedId;
      } else {
        this.selectedIds.forEach(selectedId => {
          idMap[selectedId.id] = selectedId.status;
        });
        updateKeyValueMap[this.columnKey + '#id'] = idMap;
      }
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-tug-boats {
  .dialog-content {
    flex-wrap: wrap;
  }
  .pm-dialog-equipment-col {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:5px;
      height:2.2rem;
      font-size: 120%;
    }
    .pm-chip-with-border {
      border:2px solid $pm-blue;
    }
    .pm-chip-without-border {
      border:1px solid #828282;
    }
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

